@import "/src/variables/font_size";
@import "/src/variables/color";
@import "/src/variables/font";
@import "/src/variables/tokens";
.loadContainer {
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: $space-30;
  .loaderText {
    color: $White;
    font-family: $font-primary;
    font-weight: $font-weight-semibold;
    letter-spacing: 0.266px;
    line-height: $line-height-15-24;
    margin-top: $space-24-25;
    // margin-bottom: 30.13px;

    @media screen and (max-width: 500px) {
      font-size: 2.771vw;
      letter-spacing: 0.059vw;
      line-height: 3.387vw;
      margin-top: 6.31vw;
      // margin-bottom: 7.313vw;
    }
  }
  .systemChatIcon {
    display: flex;
    gap: $space-10;
    align-items: center;

    .chatIcon {
      width: 32px;
    }

    .heading {
      color: $zv-text-primary--Neutral-Darker;
      font-family: $font-primary;
      font-size: $font-size-h14;
      font-weight: $font-weight-semibold;
    }
  }

  // .loader {
  //   display: inline-block;
  //   position: relative;
  //   width: 40px;
  //   height: 15px;
  // }

  // .loader span {
  //   display: block;
  //   position: absolute;
  //   top: 0;
  //   width: 7px;
  //   height: 7px;
  //   border-radius: 50%;
  //   background: var(--selected-strong);
  //   // animation: loader 1.2s ease-in-out infinite;
  //   animation: wave 1.2s ease-in-out infinite;
  // }

  // .loader span:nth-child(1) {
  //   left: 10%;
  //   animation-delay: -0.4s;
  // }

  // .loader span:nth-child(2) {
  //   left: 40%;
  //   animation-delay: -0.2s;
  // }

  // .loader span:nth-child(3) {
  //   left: 70%;
  //   animation-delay: 0s;
  // }

  // @keyframes loader {
  //   0% {
  //     transform: translateY(0);
  //   }

  //   50% {
  //     transform: translateY(-5px);
  //   }

  //   100% {
  //     transform: translateY(0);
  //   }
  // }

  // @keyframes wave {

  //   0%,
  //   100% {
  //     transform: translateY(0);
  //   }

  //   50% {
  //     transform: translateY(-10px);
  //   }
  // }
  .loader {
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: $space-1;
  }

  .circle {
    width: 20px;
    height: 20px;
    background-color: $zv-icon--gray-40-8;
    border-radius: $border-radius-round;
    margin-right: $space-2;
    animation: pulse 1.2s ease-in-out infinite;
    will-change: transform, opacity;
    transform: translateZ(0);
    -webkit-animation: pulse 1.2s ease-in-out infinite;
  }

  .circle:nth-child(2) {
    animation-delay: 0.2s;
    background-color: $zv-icon--gray-40-8;
  }

  .circle:nth-child(3) {
    animation-delay: 0.4s;
    background-color: $zv-icon--gray-40-8;
  }

  .circle:nth-child(4) {
    animation-delay: 0.6s;
    background-color: $zv-icon--gray-40-8;
  }

  .whiteCircle {
    background-color: $zv-text-muted--gray-76-9;
  }

  .whiteCircle:nth-child(2) {
    animation-delay: 0.2s;
    background-color: $zv-text-muted--gray-76-9;
  }

  .whiteCircle:nth-child(3) {
    animation-delay: 0.4s;
    background-color: $zv-text-muted--gray-76-9;
  }

  .whiteCircle:nth-child(4) {
    animation-delay: 0.6s;
    background-color: $zv-text-muted--gray-76-9;
  }

  @keyframes pulse {
    0% {
      transform: scale(0.9);
      -webkit-transform: scale(0.9);
      opacity: 0.5;
    }

    50% {
      transform: scale(1);
      -webkit-transform: scale(1);
      opacity: 0.7;
    }

    100% {
      transform: scale(0.9);
      -webkit-transform: scale(0.9);
      opacity: 1;
    }
  }
}
